import { defineComponent as _defineComponent } from 'vue'
import { toRef } from 'vue'
import VsText from '@/components/vision/VsText.vue'
import VsCard from '@/components/vision/VsCard.vue'
import { useLocationQuery } from '@/api/locations'
import { RouterLinkProps } from 'vue-router/types/router'

type RouterLinkTo = RouterLinkProps['to']


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationCard',
  props: {
    locationId: null,
    jobCount: null,
    linkTo: null
  },
  setup(__props: any) {

const props = __props as {
  locationId: string
  jobCount?: number
  linkTo: RouterLinkTo
}



const locationIdRef = toRef(props, 'locationId')
const { data: location } = useLocationQuery(locationIdRef)

return { __sfc: true,props, locationIdRef, location, VsText, VsCard }
}

})